import gql from 'graphql-tag';

export default gql`
query ($id: String!, $version: Int!) {
  getEtlPackage (id: $id, version: $version) {
    __typename
    id
    name
    version
    objects
    queries {
      __typename
      id
      etlPackageId
      icon
      parent_ids
      step
      x
      y
      settings {
        name
        tableId
        compressed
        manifest
        escapeDelimiter
        csvFile
        delimiter
        ignoreHeaderRows
        copyOnly
        copyFormatRegex
      }
      columns {
        id
        order
        name
        type
        dataType
        defaultValue
        isIdentity
        alias
        maxLength
        scale
        defaultValueIsFunction
      }
    }
    matrix
    scale
    executions {
      id
      order
      status
      statusMessage
      steps {
        queryId
        status
        statusMessage
      }
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackages/GetQuery.js